import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/reason.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { ReasonEffects } from './state/reason.effects';
import { SortableColumnModule } from '../../sortableColumn/sortableColumn.module';
import { ReasonEditShellComponent } from './containers/reason-edit-shell/reason-edit-shell.component';
import { ReasonListComponent } from './components/reason-list/reason-list.component';
import { ReasonEditComponent } from './components/reason-edit/reason-edit.component';
import { ReasonShellComponent } from './containers/reason-shell/reason-shell.component';



@NgModule({
  declarations: [
    ReasonShellComponent,
    ReasonEditShellComponent,
    ReasonListComponent,
    ReasonEditComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('reasons', reducer),
    EffectsModule.forFeature([ReasonEffects]),
    SortableColumnModule
  ],
  exports: [
    ReasonListComponent,
    ReasonEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SortableColumnModule
  ]
})
export class ReasonModule {
  constructor(
  ) {}
}
